module.exports = __webpack_public_path__ + "static/media/Bicocca - DK Chocolate_White.7c084fc8.jpg";